import { useToken } from '@ori/auth';
import { TranslationsNamespaceProvider } from '@ori/i18n';
import { ErrorBoundary, LoggerProvider } from '@ori/logger';
import { Team, TestIdProvider } from '@ori/testid-generator';
import type { FC } from 'react';
import { Suspense } from 'react';

import { ApiProvider } from './components/ApiProvider';
import { PersonalMenuContent } from './components/PersonalMenuContent';
import { SkeletonLoader } from './components/SkeletonLoader';
import { APP_NAME } from './constants-generated';
import { translationsNamespace } from './constants/defaultTranslations';
import { ConfigurationProvider } from './contexts/configurationContext';
import { mainLogger } from './logger';
import type { AppConfiguration } from './models';

export interface PersonalMenuProps {
  configuration?: AppConfiguration;
}

export const PersonalMenu: FC<PersonalMenuProps> = ({ configuration }) => {
  const { isAnonymousUser, formattedToken } = useToken();

  if (isAnonymousUser || !formattedToken) {
    return <SkeletonLoader />;
  }

  return (
    <LoggerProvider logger={mainLogger}>
      <ErrorBoundary areaName="PersonalMenu">
        <ConfigurationProvider value={configuration ?? {}}>
          <ApiProvider>
            <TestIdProvider
              team={Team.Growth}
              project={APP_NAME}
            >
              <TranslationsNamespaceProvider namespace={translationsNamespace}>
                <Suspense fallback={<SkeletonLoader />}>
                  <PersonalMenuContent />
                </Suspense>
              </TranslationsNamespaceProvider>
            </TestIdProvider>
          </ApiProvider>
        </ConfigurationProvider>
      </ErrorBoundary>
    </LoggerProvider>
  );
};
